import * as React from 'react';
import {observer} from "mobx-react"
import '../index.css';

type item = {
    image : any
    header: any
    text: any
};



@observer
export default class UebergabeItem extends React.Component<item> {

    //srcIntern = '../../images/' + this.props.imgSrc + '.png';
    //srcExtern = './images/' + this.props.imgSrc + '.png';

    //image = require(this.srcIntern);



    render()
    {

        return (
                <div className="wrapper wrapperUebergaben">
                    <div className="divLeft">
                        <img src={this.props.image} className="imageUebergabe"/>
                    </div>
                    <div className="divRight">
                        <h1>
                            {this.props.header}
                        </h1>
                        <p>{this.props.text}</p>
                    </div>
                </div>


        );

    }


}


